/* tslint:disable */
/* eslint-disable */
/**
 * classes-service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export const TodoStatus = {
    Draft: 'draft',
    Active: 'active',
    Archived: 'archived'
} as const;

export type TodoStatus = typeof TodoStatus[keyof typeof TodoStatus];



